import AdlibrisIcon from '../svg/customers/adlibris-icon';
import AdlibrisLogo from '../svg/customers/adlibris-logo';
import AmazonIcon from '../svg/customers/amazon-icon';
import ApohemIcon from '../svg/customers/apohem-icon';
import ApoteaIcon from '../svg/customers/apotea-icon';
import ApoteaLogo from '../svg/customers/apotea-logo';
import ApoteketIcon from '../svg/customers/apoteket-icon';
import BlakladerIcon from '../svg/customers/blaklader-icon';
import BokusIcon from '../svg/customers/bokus-icon';
import BresserIcon from '../svg/customers/bresser-icon';
import BresserLogo from '../svg/customers/bresser-logo';
import CareOfCarlIcon from '../svg/customers/care-of-carl-icon';
import CerveraIcon from '../svg/customers/cervera-icon';
import CerveraLogo from '../svg/customers/cervera-logo';
import ClasOhlsonIcon from '../svg/customers/clas-ohlson-icon';
import DormyIcon from '../svg/customers/dormy-icon';
import ElgigantenIcon from '../svg/customers/elgiganten-icon';
import EtonShirtsIcon from '../svg/customers/eton-shirts-icon';
import GardenstoreIcon from '../svg/customers/gardenstore-icon';
import GlimjaIcon from '../svg/customers/glimja-icon';
import GlimjaLogo from '../svg/customers/glimja-logo';
import HappyGreenIcon from '../svg/customers/happy-green-icon';
import HemtexIcon from '../svg/customers/hemtex-icon';
import HorseonlineIcon from '../svg/customers/horse-online-icon';
import IkeaIcon from '../svg/customers/ikea-icon';
import InetIcon from '../svg/customers/inet-icon';
import InetLogo from '../svg/customers/inet-logo';
import IntersportIcon from '../svg/customers/intersport-icon';
import JulaIcon from '../svg/customers/jula-icon';
import JyskIcon from '../svg/customers/jysk-icon';
import KitchnIcon from '../svg/customers/kitchn-icon';
import KlintIcon from '../svg/customers/klint-icon';
import KronansApotekIcon from '../svg/customers/kronans-apotek-icon';
import LifeLogisticsIcon from '../svg/customers/life-logistics-icon';
import LindexIcon from '../svg/customers/lindex-icon';
import LykoIcon from '../svg/customers/lyko-icon';
import MatsmartIcon from '../svg/customers/martsmart-icon';
import MedsIcon from '../svg/customers/meds-icon';
import MMSportsIcon from '../svg/customers/mm-sports-icon';
import MMSportsLogo from '../svg/customers/mm-sports-logo';
import NellyIcon from '../svg/customers/nelly-icon';
import RevolutionRaceIcon from '../svg/customers/revolution-race-icon';
import StadiumIcon from '../svg/customers/stadium-icon';
import SvenskaHemIcon from '../svg/customers/svenska-hem-icon';
import TilbordsLogo from '../svg/customers/tilbords-logo';
import TwistshakeLogo from '../svg/customers/twistshake-logo';
import GlecIcon from '../svg/other/glec-icon';
import ScienceBasedTargetsIcon from '../svg/other/science-based-targets-icon';
import SvanenIcon from '../svg/other/svanen-icon';
import SkrymIcon from '../svg/skrym/skrym-icon';
import AdyenIcon from '../svg/systems/adyen-icon';
import BrinkCommerceIcon from '../svg/systems/brink-commerce-icon';
import CentraIcon from '../svg/systems/centra-icon';
import CommerceToolsIcon from '../svg/systems/commercetools-icon';
import ElementLogicIcon from '../svg/systems/element-logic-icon';
import EmotionsIcon from '../svg/systems/emotions-icon';
import EncoreIcon from '../svg/systems/encore-icon';
import FigmaIcon from '../svg/systems/figma-icon';
import GithubIcon from '../svg/systems/github-icon';
import GoogleCloudIcon from '../svg/systems/google-cloud-icon';
import GoogleDocsIcon from '../svg/systems/google-docs-icon';
import GoogleDriveIcon from '../svg/systems/google-drive-icon';
import GoogleSheetsIcon from '../svg/systems/google-sheets-icon';
import GoogleSlidesIcon from '../svg/systems/google-slides-icon';
import IMIIcon from '../svg/systems/imi-icon';
import InriverIcon from '../svg/systems/inriver-icon';
import KlarnaIcon from '../svg/systems/klarna-icon';
import KustomIcon from '../svg/systems/kustom-icon';
import MicrosoftIcon from '../svg/systems/microsoft-icon';
import NorceIcon from '../svg/systems/norce-icon';
import OngoingIcon from '../svg/systems/ongoing-icon';
import PinMeToIcon from '../svg/systems/pinmetoo-icon';
import QliroIcon from '../svg/systems/qliro-icon';
import StripeIcon from '../svg/systems/stripe-icon';
import WalleyIcon from '../svg/systems/walley-icon';
import WikipediaIcon from '../svg/systems/wikipedia-icon';
import WooCommerceIcon from '../svg/systems/woocommerce-icon';
import YoutubeIcon from '../svg/systems/youtube-icon';
import ZendeskIcon from '../svg/systems/zendesk-icon';
import AirmeeIcon from '../svg/transporters/airmee-icon';
import AirmeeLogo from '../svg/transporters/airmee-logo';
import AsendiaIcon from '../svg/transporters/asendia-icon';
import AsendiaLogo from '../svg/transporters/asendia-logo';
import BestTransportIcon from '../svg/transporters/best-transport-icon';
import BestTransportLogo from '../svg/transporters/best-transport-logo';
import BringLogo from '../svg/transporters/bring-logo';
import BringIconMiniColor from '../svg/transporters/bring-mini-icon-color';
import BudbeeIcon from '../svg/transporters/budbee-icon';
import BudbeeLogo from '../svg/transporters/budbee-logo';
import CityMailIconColor from '../svg/transporters/city-mail-icon-color';
import CityMailLogoColor from '../svg/transporters/city-mail-logo-color';
import DAOIcon from '../svg/transporters/dao-icon';
import DAOLogo from '../svg/transporters/dao-logo';
import DBSchenkerIcon from '../svg/transporters/db-schenker-icon';
import DBSchenkerLogoColor from '../svg/transporters/db-schenker-logo-color';
import DeutschePostIcon from '../svg/transporters/deutsche-post-icon';
import DeutschePostLogo from '../svg/transporters/deutsche-post-logo';
import DHLIcon from '../svg/transporters/dhl-icon';
import DHLLogo from '../svg/transporters/dhl-logo';
import DPDIcon from '../svg/transporters/dpd-icon';
import DPDLogo from '../svg/transporters/dpd-logo';
import EarlyBirdIcon from '../svg/transporters/early-bird-icon';
import EarlyBirdLogo from '../svg/transporters/early-bird-logo';
import GELExpressLogistikIcon from '../svg/transporters/gel-express-logistik-icon';
import GELExpressLogistikLogo from '../svg/transporters/gel-express-logistik-logo';
import GordonIcon from '../svg/transporters/gordon-icon';
import HelthjemIcon from '../svg/transporters/helthjem-icon';
import IcaIcon from '../svg/transporters/ica-icon';
import IcaLogo from '../svg/transporters/ica-logo';
import InstaboxIcon from '../svg/transporters/instabox-icon';
import InstaboxLogo from '../svg/transporters/instabox-logo';
import KuehneNagelIcon from '../svg/transporters/kuehne-nagel-icon';
import KuehneNagelLogo from '../svg/transporters/kuehne-nagel-logo';
import LGTLogisticsIcon from '../svg/transporters/lgt-logistics-icon';
import LGTLogisticsLogo from '../svg/transporters/lgt-logistics-logo';
import MoveByBikeIcon from '../svg/transporters/move-by-bike-icon';
import MoveByBikeLogo from '../svg/transporters/move-by-bike-logo';
import PostNLIcon from '../svg/transporters/post-nl-icon';
import PostNLLogo from '../svg/transporters/post-nl-logo';
import PostiIcon from '../svg/transporters/posti-icon';
import PostiLogo from '../svg/transporters/posti-logo';
import PostnordIcon from '../svg/transporters/postnord-icon';
import PostnordLogo from '../svg/transporters/postnord-logo';
import RoyalMailIcon from '../svg/transporters/royal-mail-icon';
import RoyalMailLogo from '../svg/transporters/royal-mail-logo';
import SwissPostIcon from '../svg/transporters/swiss-post-icon';
import SwissPostLogo from '../svg/transporters/swiss-post-logo';
import UPSIconColor from '../svg/transporters/ups-icon';
import UPSLogoColor from '../svg/transporters/ups-logo';
import USPSIcon from '../svg/transporters/usps-icon';
import USPSLogo from '../svg/transporters/usps-logo';
import { caseInsensitiveStringCompare } from '../utils/stringutils';

export interface PackageVisualizationColors {
  backgroundColor: string;
  logoColor: string;
  tapeColor?: string;
  lineColorDarkenAmount?: number; // override the default darken amount (0.125) for the line color (certain colors make it look a little weird)
}

export interface OrganizationColors {
  light?: string;
  main: string;
  logo: string;
  background: string;
  dark?: string;
  textOnBg: string;
  linearChartScheme?: string[];
  contrastingChartScheme?: string[];
  packageVisualizationColors?: PackageVisualizationColors;
}

export interface OrganizationAssets {
  organizationId?: string;
  additionalIds?: string[]; // e.g. when an organization has multiple ids
  type: 'transporter' | 'system' | 'retailer' | 'skrym' | 'other';
  organizationName: string;
  additionalNames?: string[]; // e.g. when an organization has multiple names
  darkColors?: OrganizationColors;
  lightColors?: OrganizationColors;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  logo?: React.FC<React.SVGProps<SVGSVGElement>>;
}

// TODO: add some sample chart schemes that can be used for transporters
export const redChartScheme = [
  '#FFCDD2',
  '#EF9A9A',
  '#E57373',
  '#EF5350',
  '#E53935',
  '#D32F2F',
  '#C62828',
  '#B71C1C',
];

export const pinkChartScheme = [
  '#F8BBD0',
  '#F48FB1',
  '#F06292',
  '#EC407A',
  '#E91E63',
  '#D81B60',
  '#C2185B',
  '#AD1457',
  '#880E4F',
];

export const purpleChartScheme = [
  '#E1BEE7',
  '#CE93D8',
  '#BA68C8',
  '#AB47BC',
  '#9C27B0',
  '#7B1FA2',
  '#6A1B9A',
];

export const deepPurpleChartScheme = [
  '#D1C4E9',
  '#B39DDB',
  '#9575CD',
  '#7E57C2',
  '#673AB7',
  '#512DA8',
  '#4527A0',
];

export const indigoChartScheme = [
  '#C5CAE9',
  '#9FA8DA',
  '#7986CB',
  '#5C6BC0',
  '#3F51B5',
  '#303F9F',
  '#283593',
];

export const blueChartScheme = [
  '#BBDEFB',
  '#90CAF9',
  '#64B5F6',
  '#42A5F5',
  '#2196F3',
  '#1E88E5',
  '#1976D2',
  '#1565C0',
  '#0D47A1',
];

export const lightBlueChartScheme = [
  '#B3E5FC',
  '#81D4FA',
  '#4FC3F7',
  '#29B6F6',
  '#03A9F4',
  '#039BE5',
  '#0288D1',
  '#0277BD',
  '#01579B',
];

export const cyanChartScheme = [
  '#B2EBF2',
  '#80DEEA',
  '#4DD0E1',
  '#26C6DA',
  '#00BCD4',
  '#00ACC1',
  '#0097A7',
  '#00838F',
  '#006064',
];

export const tealChartScheme = [
  '#B2DFDB',
  '#80CBC4',
  '#4DB6AC',
  '#26A69A',
  '#009688',
  '#00897B',
  '#00796B',
  '#00695C',
  '#004D40',
];

export const greenChartScheme = [
  '#C8E6C9',
  '#A5D6A7',
  '#81C784',
  '#66BB6A',
  '#4CAF50',
  '#43A047',
  '#388E3C',
  '#2E7D32',
  '#1B5E20',
];

export const lightGreenChartScheme = [
  '#DCEDC8',
  '#C5E1A5',
  '#AED581',
  '#9CCC65',
  '#8BC34A',
  '#7CB342',
  '#689F38',
  '#558B2F',
  '#33691E',
];

export const limeChartScheme = [
  '#F0F4C3',
  '#E6EE9C',
  '#DCE775',
  '#CDDC39',
  '#C0CA33',
  '#AFB42B',
  '#9E9D24',
  '#827717',
];

export const yellowChartScheme = ['#FFF9C4', '#FFF59D', '#FFEB3B', '#FBC02D', '#F57F17'];

export const amberChartScheme = ['#FFECB3', '#FFD54F', '#FFC107', '#FFA000', '#FF6F00'];

export const orangeChartScheme = [
  '#FFE0B2',
  '#FFCC80',
  '#FFB74D',
  '#FFA726',
  '#FF9800',
  '#FB8C00',
  '#F57C00',
  '#EF6C00',
  '#E65100',
];

export const deepOrangeChartScheme = [
  '#FFCCBC',
  '#FFAB91',
  '#FF8A65',
  '#FF7043',
  '#FF5722',
  '#F4511E',
  '#E64A19',
  '#D84315',
  '#BF360C',
];

export const brownChartScheme = [
  '#D7CCC8',
  '#BCAAA4',
  '#A1887F',
  '#8D6E63',
  '#795548',
  '#6D4C41',
  '#5D4037',
  '#4E342E',
  '#3E2723',
];

export const greyChartScheme = [
  '#EEEEEE',
  '#E0E0E0',
  '#BDBDBD',
  '#9E9E9E',
  '#757575',
  '#616161',
  '#424242',
  '#212121',
];

export const blueGreyChartScheme = [
  '#CFD8DC',
  '#B0BEC5',
  '#90A4AE',
  '#78909C',
  '#607D8B',
  '#546E7A',
  '#455A64',
  '#37474F',
  '#263238',
];

export const viridisChartScheme = [
  '#fde725',
  '#a0da39',
  '#4ac16d',
  '#1fa187',
  '#277f8e',
  '#365c8d',
  '#46327e',
  '#440154',
];

export const plasmaChartScheme = [
  '#f0f921',
  '#febd2a',
  '#f48849',
  '#db5c68',
  '#b83289',
  '#8b0aa5',
  '#5302a3',
  '#0d0887',
];

export const postnord = {
  organizationId: 'fc1432c9-b3f8-41ea-826c-e3afd829c4a4',
  organizationName: 'Postnord',
  type: 'transporter',
  icon: PostnordIcon,
  logo: PostnordLogo,
  lightColors: {
    light: '#ffffff',
    main: '#269fd7',
    background: '#269fd7',
    logo: '#ffffff',
    dark: '#1e1e1e',
    textOnBg: '#ffffff',
    linearChartScheme: blueChartScheme,
  },
  darkColors: {
    light: '#ffffff',
    main: '#269fd7',
    background: '#163a47',
    logo: '#269fd7',
    dark: '#1e1e1e',
    textOnBg: '#5ec5ea',
    linearChartScheme: blueChartScheme,
  },
} as const satisfies OrganizationAssets;

export const dbSchenker = {
  organizationId: '6a92c0e6-dca9-4170-a518-7bea880400b6',
  organizationName: 'DB Schenker',
  type: 'transporter',
  icon: DBSchenkerIcon,
  logo: DBSchenkerLogoColor,
  darkColors: {
    light: '#eeeeee',
    main: '#ffffff',
    background: '#555555',
    logo: '#aaaaaa',
    dark: '#1a1a1a',
    textOnBg: '#1a1a1a',
    linearChartScheme: redChartScheme,
  },
  lightColors: {
    light: '#eeeeee',
    main: '#ffffff',
    background: '#eeeeee',
    logo: '#d40511',
    dark: '#1a1a1a',
    textOnBg: '#1a1a1a',
    linearChartScheme: redChartScheme,
  },
} as const satisfies OrganizationAssets;

export const earlyBird = {
  organizationId: 'd4368205-22ae-46f7-9f1f-e3827c7ea570',
  organizationName: 'Early Bird',
  type: 'transporter',

  icon: EarlyBirdIcon,
  logo: EarlyBirdLogo,
  darkColors: {
    light: '#faefe8',
    main: '#dd7f4b',
    background: '#4c2a19',
    logo: '#efb497',
    dark: '#dd7f4b',
    textOnBg: '#ffffff',
    linearChartScheme: ['#4c2a19', '#faefe8', '#dd7f4b'],
  },
  lightColors: {
    light: '#faefe8',
    main: '#dd7f4b',
    background: '#dd7f4b',
    logo: '#faefe8',
    dark: '#dd7f4b',
    textOnBg: '#ffffff',
    linearChartScheme: ['#dd7f4b', '#faefe8', '#dd7f4b'],
  },
} as const satisfies OrganizationAssets;

export const airmee = {
  organizationId: 'f89a49e3-6718-489a-8311-a0431be663bd',
  organizationName: 'Airmee',
  type: 'transporter',

  icon: AirmeeIcon,
  logo: AirmeeLogo,
  lightColors: {
    light: '#ffffff',
    main: '#000000',
    dark: '#000000',
    background: '#000000',
    logo: '#ffffff',
    textOnBg: '#ffffff',
    linearChartScheme: greyChartScheme,
  },
  darkColors: {
    light: '#ffffff',
    main: '#000000',
    dark: '#000000',
    background: '#222222',
    logo: '#bbbbbb',
    textOnBg: '#ffffff',
    linearChartScheme: greyChartScheme,
  },
} as const satisfies OrganizationAssets;

export const gordon = {
  organizationId: 'f86e65d2-a938-4617-b92e-284197d43a27',
  organizationName: 'Gordon',
  type: 'transporter',

  icon: GordonIcon,
  lightColors: {
    light: '#ffffff',
    main: '#000000',
    dark: '#000000',
    background: '#000000',
    logo: '#ffffff',
    textOnBg: '#ffffff',
    linearChartScheme: greyChartScheme,
  },
  darkColors: {
    light: '#ffffff',
    main: '#000000',
    dark: '#000000',
    background: '#222222',
    logo: '#bbbbbb',
    textOnBg: '#ffffff',
    linearChartScheme: greyChartScheme,
  },
} as const satisfies OrganizationAssets;

export const dhl = {
  organizationId: 'f2d83dd5-374a-4ef1-8946-af7800d798ea',
  organizationName: 'DHL',
  type: 'transporter',

  icon: DHLIcon,
  logo: DHLLogo,
  lightColors: {
    light: '#fcce00',
    main: '#d40711',
    dark: '#191919',
    background: '#fcce00',
    logo: '#d40711',
    textOnBg: '#d40711',
    linearChartScheme: yellowChartScheme,
  },
  darkColors: {
    light: '#fcce00',
    main: '#d40711',
    dark: '#191919',
    background: '#3d1414',
    logo: '#d40711',
    textOnBg: '#d40711',
    linearChartScheme: redChartScheme,
  },
} as const satisfies OrganizationAssets;

export const budbee = {
  organizationId: '09c96082-2eb5-412b-9f4a-71d236c7be93',
  organizationName: 'Budbee',
  type: 'transporter',

  icon: BudbeeIcon,
  logo: BudbeeLogo,
  lightColors: {
    light: '#f8fbfb',
    main: '#41cda5',
    dark: '#1b6f6c',
    background: '#41cda5',
    logo: '#f8fbfb',
    textOnBg: '#f8fbfb',
    linearChartScheme: greenChartScheme,
  },
  darkColors: {
    light: '#f8fbfb',
    main: '#41cda5',
    dark: '#1b6f6c',
    background: '#1c3d34',
    logo: '#41cda5',
    textOnBg: '#f8fbfb',
    linearChartScheme: greenChartScheme,
  },
} as const satisfies OrganizationAssets;

export const citymail = {
  organizationId: 'b015de0f-b2d4-43c1-bb4b-77e12e127e8f',
  organizationName: 'Citymail',
  type: 'transporter',

  icon: CityMailIconColor,
  logo: CityMailLogoColor,
  lightColors: {
    light: '#edeeee',
    main: '#21b140',
    dark: '#fa4c02',
    background: '#edeeee',
    logo: '#fa4c02',
    textOnBg: '#1a1a1a',
    linearChartScheme: limeChartScheme,
  },
  darkColors: {
    light: '#edeeee',
    main: '#21b140',
    dark: '#fa4c02',
    background: '#555555',
    logo: '#fa4c02',
    textOnBg: '#1a1a1a',
    linearChartScheme: limeChartScheme,
  },
} as const satisfies OrganizationAssets;

export const instabox = {
  organizationId: '6ca892f6-d047-4665-8409-2ce980214242',
  organizationName: 'Instabox',
  type: 'transporter',

  icon: InstaboxIcon,
  logo: InstaboxLogo,
  lightColors: {
    light: '#ffe6e5',
    main: '#ff3e3e',
    background: '#ff3e3e',
    dark: '#585050',
    logo: '#ffffff',
    textOnBg: '#ffffff',
    linearChartScheme: redChartScheme,
  },
  darkColors: {
    light: '#ffe6e5',
    main: '#ff3e3e',
    background: '#3d1414',
    dark: '#585050',
    logo: '#ff3e3e',
    textOnBg: '#ffffff',
    linearChartScheme: redChartScheme,
  },
} as const satisfies OrganizationAssets;

export const bring = {
  organizationId: 'a4dfe31b-eda4-4598-8fa5-f562d16be08f',
  organizationName: 'Bring',
  type: 'transporter',

  icon: BringIconMiniColor,
  logo: BringLogo,
  lightColors: {
    light: '#f6f6f6',
    main: '#7ac144',
    background: '#7ac144',
    logo: '#f6f6f6',
    dark: '#000000',
    textOnBg: '#ffffff',
    linearChartScheme: limeChartScheme,
  },
  darkColors: {
    light: '#f6f6f6',
    main: '#7ac144',
    background: '#222d19',
    logo: '#7ac144',
    dark: '#000000',
    textOnBg: '#ffffff',
    linearChartScheme: limeChartScheme,
  },
} as const satisfies OrganizationAssets;

export const ica = {
  organizationId: '6ddbb930-144b-45f9-aeb6-4efa5b68334d',
  organizationName: 'ICA',
  type: 'transporter',

  icon: IcaIcon,
  logo: IcaLogo,
  darkColors: {
    light: '#ffe6e5',
    main: '#ff3e3e',
    background: '#3d1414',
    dark: '#ff3e3e',
    logo: '#ff3e3e',
    textOnBg: '#ff3e3e',
    linearChartScheme: redChartScheme,
  },
  lightColors: {
    light: '#ffe6e5',
    main: '#ff3e3e',
    background: '#eeeeee',
    dark: '#ff3e3e',
    logo: '#ff3e3e',
    textOnBg: '#ff3e3e',
    linearChartScheme: redChartScheme,
  },
} as const satisfies OrganizationAssets;

export const posti = {
  organizationId: '2b6444cc-80d3-4fed-a3a0-2783af58277a',
  organizationName: 'Posti',
  type: 'transporter',

  icon: PostiIcon,
  logo: PostiLogo,
  lightColors: {
    light: '#ffffff',
    main: '#fc8003',
    background: '#fc8003',
    logo: '#ffffff',
    dark: '#3b4b58',
    textOnBg: '#ffffff',
    linearChartScheme: orangeChartScheme,
  },
  darkColors: {
    light: '#ffffff',
    main: '#fc8003',
    background: '#512705',
    logo: '#fc8003',
    dark: '#3b4b58',
    textOnBg: '#ffffff',
    linearChartScheme: orangeChartScheme,
  },
} as const satisfies OrganizationAssets;

export const postNl = {
  organizationId: '0e8b1365-3a5e-4e01-8f7a-7790a68a4deb',
  organizationName: 'PostNL',
  type: 'transporter',

  icon: PostNLIcon,
  logo: PostNLLogo,
  lightColors: {
    light: '#ffffff',
    main: '#fc8003',
    background: '#fc8003',
    logo: '#ffffff',
    dark: '#3b4b58',
    textOnBg: '#ffffff',
    linearChartScheme: orangeChartScheme,
  },
  darkColors: {
    light: '#ffffff',
    main: '#fc8003',
    background: '#512705',
    logo: '#fc8003',
    dark: '#3b4b58',
    textOnBg: '#ffffff',
    linearChartScheme: orangeChartScheme,
  },
} as const satisfies OrganizationAssets;

export const bestTransport = {
  organizationId: 'af89dc0c-6a87-4a4e-ae91-9de89685c799',
  organizationName: 'Best Transport',
  type: 'transporter',

  icon: BestTransportIcon,
  logo: BestTransportLogo,
  darkColors: {
    light: '#F9E7E3',
    main: '#fc8003',
    background: '#fc8003',
    logo: '#ffffff',
    dark: '#801600',
    textOnBg: '#ffffff',
    linearChartScheme: orangeChartScheme,
  },
  lightColors: {
    light: '#F9E7E3',
    main: '#fc8003',
    background: '#fc8003',
    logo: '#ffffff',
    dark: '#801600',
    textOnBg: '#ffffff',
    linearChartScheme: orangeChartScheme,
  },
} as const satisfies OrganizationAssets;

export const ups = {
  organizationId: '4aa8c0dd-7cb0-4d40-8354-1845b3794830',
  organizationName: 'UPS',
  type: 'transporter',

  icon: UPSIconColor,
  logo: UPSLogoColor,
  lightColors: {
    light: '#ffb500',
    main: '#351c15',
    background: '#351c15',
    logo: '#ffb500',
    dark: '#351c15',
    textOnBg: '#ffb500',
    linearChartScheme: brownChartScheme,
  },
  darkColors: {
    light: '#ffb500',
    main: '#351c15',
    background: '#351c15',
    logo: '#ffb500',
    dark: '#351c15',
    textOnBg: '#ffb500',
    linearChartScheme: brownChartScheme,
  },
} as const satisfies OrganizationAssets;

export const dao = {
  organizationId: '0ec9d8cd-c9f2-4312-8ca5-37af3c402830',
  organizationName: 'DAO',
  icon: DAOIcon,
  logo: DAOLogo,
  type: 'transporter',

  lightColors: {
    light: '#eeeeee',
    main: '#d40511',
    logo: '#eeeeee',
    background: '#d40511',
    dark: '#1a1a1a',
    textOnBg: '#eeeeee',
    linearChartScheme: redChartScheme,
  },
  darkColors: {
    light: '#eeeeee',
    main: '#d40511',
    logo: '#eeeeee',
    background: '#d40511',
    dark: '#1a1a1a',
    textOnBg: '#eeeeee',
    linearChartScheme: redChartScheme,
  },
} as const satisfies OrganizationAssets;

export const moveByBike = {
  organizationId: 'b448e8b4-ed01-46d9-83e9-a59041e1a530',
  organizationName: 'Move By Bike',
  type: 'transporter',

  icon: MoveByBikeIcon,
  logo: MoveByBikeLogo,
  darkColors: {
    light: '#F4FAF4',
    main: '#56A854',
    logo: '#FDF150',
    background: '#193011',
    dark: '#005403',
    textOnBg: '#FDF150',
    linearChartScheme: greenChartScheme,
  },
  lightColors: {
    light: '#F4FAF4',
    main: '#56A854',
    logo: '#FDF150',
    background: '#56A854',
    dark: '#005403',
    textOnBg: '#FDF150',
    linearChartScheme: greenChartScheme,
  },
} as const satisfies OrganizationAssets;

export const kuehneNagel = {
  organizationId: '0a9a06b4-3661-48ff-9dfa-c3d42917d081',
  organizationName: 'Kuehne+Nagel',
  type: 'transporter',

  icon: KuehneNagelIcon,
  logo: KuehneNagelLogo,
  lightColors: {
    light: '#eeeeee',
    main: '#012257',
    logo: '#eeeeee',
    background: '#012257',
    dark: '#012257',
    textOnBg: '#eeeeee',
    linearChartScheme: blueChartScheme,
  },
  darkColors: {
    light: '#eeeeee',
    main: '#14A1EB',
    logo: '#012257',
    background: '##14A1EB',
    dark: '#012257',
    textOnBg: '#012257',
    linearChartScheme: blueChartScheme,
  },
} as const satisfies OrganizationAssets;

export const gelExpressLogistik = {
  organizationId: 'e0bacffc-79fa-4d59-9c91-cbecab4701b1',
  organizationName: 'GEL Express Logistik',
  type: 'transporter',

  icon: GELExpressLogistikIcon,
  logo: GELExpressLogistikLogo,
  darkColors: {
    light: '#FFFFFF',
    main: '#E30613',
    logo: '#FFFFFF',
    background: '#E30613',
    dark: '#5E1018',
    textOnBg: '#FFFFFF',
    linearChartScheme: redChartScheme,
  },
  lightColors: {
    light: '#FFFFFF',
    main: '#E30613',
    logo: '#FFFFFF',
    background: '#E30613',
    dark: '#5E1018',
    textOnBg: '#FFFFFF',
    linearChartScheme: redChartScheme,
  },
} as const satisfies OrganizationAssets;

export const dpd = {
  organizationId: '716ed06c-ece5-46da-8de9-bf2ff9f48622',
  organizationName: 'DPD',
  type: 'transporter',

  icon: DPDIcon,
  logo: DPDLogo,
  lightColors: {
    light: '#eeeeee',
    main: '#d40511',
    logo: '#3f3f42',
    background: '#eeeeee',
    dark: '#1a1a1a',
    textOnBg: '#d40511',
    linearChartScheme: redChartScheme,
  },
  darkColors: {
    light: '#eeeeee',
    main: '#db0032',
    logo: '#eeeeee',
    background: '#eeeeee',
    dark: '#1a1a1a',
    textOnBg: '#db0032',
    linearChartScheme: redChartScheme,
  },
} as const satisfies OrganizationAssets;

export const lgtLogistics = {
  organizationId: '9d438fdc-a3ff-4f43-85ad-e793fbbc1e07',
  organizationName: 'LGT Logistics',
  icon: LGTLogisticsIcon,
  type: 'transporter',

  logo: LGTLogisticsLogo,
  darkColors: {
    light: '#f6f6f6',
    main: '#7ac144',
    background: '#222d19',
    logo: '#7ac144',
    dark: '#000000',
    textOnBg: '#ffffff',
    linearChartScheme: greenChartScheme,
  },
  lightColors: {
    light: '#f6f6f6',
    main: '#7ac144',
    background: '#355848',
    logo: '#f6f6f6',
    dark: '#000000',
    textOnBg: '#ffffff',
    linearChartScheme: greenChartScheme,
  },
} as const satisfies OrganizationAssets;

export const usps = {
  organizationId: '5ad79aaa-31fa-43c6-8f68-842c585d7451',
  organizationName: 'USPS',
  icon: USPSIcon,
  type: 'transporter',

  logo: USPSLogo,
  lightColors: {
    light: '#29629B',
    main: '#262453',
    background: '#262453',
    logo: '#ffffff',
    dark: '#262453',
    textOnBg: '#ffffff',
    linearChartScheme: blueChartScheme,
  },
} as const satisfies OrganizationAssets;

export const royalMail = {
  organizationId: '69794f6d-1c15-47cb-805b-1feeb8a02e0c',
  organizationName: 'Royal Mail',
  type: 'transporter',

  icon: RoyalMailIcon,
  logo: RoyalMailLogo,
  lightColors: {
    light: '#FCD41E',
    main: '#CE0221',
    background: '#CE0221',
    logo: '#ffffff',
    dark: '#000000',
    textOnBg: '#ffffff',
    linearChartScheme: redChartScheme,
  },
} as const satisfies OrganizationAssets;

export const asendia = {
  organizationId: 'b8ea2446-5d48-425b-a381-afc2f747aded',
  organizationName: 'Asendia',
  type: 'transporter',

  icon: AsendiaIcon,
  logo: AsendiaLogo,
  lightColors: {
    light: '#36727C',
    main: '#094B57',
    background: '#094B57',
    logo: '#ffffff',
    dark: '#000000',
    textOnBg: '#ffffff',
  },
  darkColors: {
    light: '#36727C',
    main: '#FEF30C',
    background: '#094B57',
    logo: '#ffffff',
    dark: '#000000',
    textOnBg: '#ffffff',
  },
} as const satisfies OrganizationAssets;

export const deutschePost = {
  organizationId: '083088b3-5378-4de0-8d4c-dc0d76db6e8b',
  organizationName: 'Deutsche Post',
  type: 'transporter',

  icon: DeutschePostIcon,
  logo: DeutschePostLogo,
  lightColors: {
    light: '#f6f6f6',
    main: '#FEC30A',
    background: '#FEC30A',
    logo: '#000000',
    dark: '#000000',
    textOnBg: '#000000',
    linearChartScheme: yellowChartScheme,
  },
} as const satisfies OrganizationAssets;

export const swissPost = {
  organizationId: '711728e3-ce24-4fff-b4b4-682db0c4c3b1',
  organizationName: 'Swiss Post',
  type: 'transporter',

  icon: SwissPostIcon,
  logo: SwissPostLogo,
  lightColors: {
    light: '#f6f6f6',
    main: '#FEC30A',
    background: '#FEC30A',
    logo: '#000000',
    dark: '#000000',
    textOnBg: '#000000',
    linearChartScheme: yellowChartScheme,
  },
} as const satisfies OrganizationAssets;

export const helthjem = {
  organizationId: '1386831a-b644-4ddd-aa02-609a34a1dff9',
  organizationName: 'Helthjem',
  type: 'transporter',

  icon: HelthjemIcon,
  logo: HelthjemIcon,
  lightColors: {
    light: '#ffffff',
    main: '#EEBB40',
    background: '#EEBB40',
    logo: '#ffffff',
    dark: '#3b4b58',
    textOnBg: '#ffffff',
    linearChartScheme: yellowChartScheme,
  },
} as const satisfies OrganizationAssets;

export const organizationAssets: OrganizationAssets[] = [
  {
    organizationId: 'f8ffc2fc-cecd-4a41-a05c-347423a8efe4',
    organizationName: 'Hemtex',
    type: 'retailer',
    icon: HemtexIcon,
    lightColors: {
      light: '#ffffff',
      main: '#122838',
      background: '#000000',
      logo: '#ffffff',
      dark: '#000000',
      textOnBg: '#ffffff',
    },
  },
  {
    organizationId: '2ad25049-f750-463a-a18d-bcdc0a3c1ca5',
    organizationName: 'Twistshake',
    type: 'retailer',
    logo: TwistshakeLogo,
    icon: TwistshakeLogo,
    lightColors: {
      light: '#ffffff',
      main: '#122838',
      background: '#EBB4C9',
      logo: '#000000',
      dark: '#000000',
      textOnBg: '#ffffff',
    },
  },
  {
    organizationId: 'bac69c35-c4fe-4674-b309-bb4bcc9466cd',
    organizationName: 'Adlibris',
    type: 'retailer',
    icon: AdlibrisIcon,
    logo: AdlibrisLogo,
    lightColors: {
      light: '#ffffff',
      main: '#C73428',
      background: '#C73428',
      logo: '#ffffff',
      dark: '#000000',
      textOnBg: '#ffffff',
    },
  },
  {
    organizationId: 'e199c58b-2ebc-4da8-898d-67b518558086',
    organizationName: 'Dormy',
    type: 'retailer',
    icon: DormyIcon,
    lightColors: {
      light: '#ffffff',
      main: '#B52C24',
      background: '#B52C24',
      logo: '#ffffff',
      dark: '#000000',
      textOnBg: '#ffffff',
    },
  },
  {
    organizationId: '7e249a05-2249-402c-81f1-ac3580c764f9',
    organizationName: 'Lyko',
    type: 'retailer',
    icon: LykoIcon,
    lightColors: {
      light: '#ffffff',
      main: '#3E454B',
      background: '#3E454B',
      logo: '#ffffff',
      dark: '#3E454B',
      textOnBg: '#ffffff',
    },
  },
  {
    organizationId: '39b89c46-e49f-4780-ac69-29a3ef6abae4',
    organizationName: 'Kronans Apotek',
    type: 'retailer',
    icon: KronansApotekIcon,
    lightColors: {
      light: '#ffffff',
      main: '#F1A23F',
      background: '#FAF8F5',
      logo: '#F1A23F',
      dark: '#F1A23F',
      textOnBg: '#F1A23F',
    },
  },
  {
    organizationId: '6dd8bd71-e476-43bb-a66d-0a74e9cfb082',
    organizationName: 'Apohem',
    type: 'retailer',
    icon: ApohemIcon,
    lightColors: {
      light: '#ffffff',
      main: '#5ABACA',
      background: '#5ABACA',
      logo: '#ffffff',
      dark: '#5ABACA',
      textOnBg: '#5ABACA',
    },
  },
  {
    organizationId: '0a96434c-1be2-49a8-9a25-a023ba43fdc2',
    organizationName: 'Apoteket',
    type: 'retailer',
    icon: ApoteketIcon,
    lightColors: {
      light: '#ffffff',
      main: '#4eab32',
      background: '#4eab32',
      logo: '#ffffff',
      dark: '#4eab32',
      textOnBg: '##fff',
    },
  },
  {
    organizationId: '0dabf198-1741-41dc-b6d9-0644b8cd5769',
    organizationName: 'Clas Ohlson',
    type: 'retailer',
    icon: ClasOhlsonIcon,
    lightColors: {
      light: '#ffffff',
      main: '#90D5F7',
      background: '#90D5F7',
      logo: '#000',
      dark: '#90D5F7',
      textOnBg: '#000',
    },
  },
  {
    organizationId: '180cbc0f-6e9c-46ce-8080-3066eaf924f7',
    organizationName: 'InterSport',
    type: 'retailer',
    icon: IntersportIcon,
    lightColors: {
      light: '#ffffff',
      main: '#173E92',
      background: '#F5F5F5',
      logo: '#173E92',
      dark: '#ffffff',
      textOnBg: '#173E92',
    },
  },
  {
    organizationId: 'a78b2d12-c840-4f84-8a31-87fb63a1e9a6',
    organizationName: 'Elgiganten',
    type: 'retailer',
    icon: ElgigantenIcon,
    lightColors: {
      light: '#ffffff',
      main: '#0C1C57',
      background: '#0C1C57',
      logo: '#7EA84B',
      dark: '#ffffff',
      textOnBg: '#fff',
    },
  },
  {
    organizationId: 'b7344995-29ec-40bd-bdb4-8ecc0056b85e',
    organizationName: 'IKEA',
    type: 'retailer',
    icon: IkeaIcon,
    lightColors: {
      light: '#ffffff',
      main: '#f4d94c',
      background: '#2457a4',
      logo: '#f4d94c',
      dark: '#2457a4',
      textOnBg: '#fff',
    },
  },
  {
    organizationId: '01260a84-ca03-473d-ad64-08a9413fa45d',
    organizationName: 'Amazon',
    type: 'retailer',
    icon: AmazonIcon,
    lightColors: {
      light: '#ffffff',
      main: '#F19E38',
      background: '#252F3D',
      logo: '#fff',
      dark: '#252F3D',
      textOnBg: '#fff',
    },
  },
  {
    organizationName: 'Eton',
    type: 'retailer',
    organizationId: 'c68b770b-181e-4310-a61d-b30acd6ce2b0',
    icon: EtonShirtsIcon,
    lightColors: {
      light: '#ffffff',
      main: '#0C112E',
      background: '#0C112E',
      logo: '#ffffff',
      dark: '#0C112E',
      textOnBg: '#ffffff',
    },
  },
  {
    organizationName: 'Stadium',
    type: 'retailer',
    organizationId: 'c0bf2032-0494-4b9e-8a24-05799fa35d2b',
    icon: StadiumIcon,
    lightColors: {
      light: '#ffffff',
      main: '#EA6E2D',
      background: '#EA6E2D',
      logo: '#000',
      dark: '#EA6E2D',
      textOnBg: '#000',
    },
  },
  {
    organizationName: 'Matsmart',
    type: 'retailer',
    organizationId: '93618d65-5e05-4c6c-9fd2-18827a6835f3',
    icon: MatsmartIcon,
    lightColors: {
      light: '#ffffff',
      main: '#E4313E',
      background: '#F4B840',
      logo: '-',
      dark: '#081D5E',
      textOnBg: '#081D5E',
    },
  },
  {
    organizationName: 'Bokus',
    type: 'retailer',
    organizationId: 'c9ace900-4fbb-4e69-b1ef-a8793b8b187d',
    icon: BokusIcon,
    lightColors: {
      light: '#ffffff',
      main: '#EA6E2D',
      background: '#EA6E2D',
      logo: '#fff',
      dark: '#EA6E2D',
      textOnBg: '#fff',
    },
  },
  {
    organizationName: 'Jysk',
    type: 'retailer',
    organizationId: 'b6f3db53-2715-413b-a97f-64b093213fd6',
    icon: JyskIcon,
    lightColors: {
      light: '#ffffff',
      main: '#143c8A',
      background: '#143c8A',
      logo: '#fff',
      dark: '#143c8A',
      textOnBg: '#fff',
    },
  },
  {
    organizationName: 'Care of Carl',
    type: 'retailer',
    organizationId: '8413fd4a-213e-4a62-b193-ecbf83415928',
    icon: CareOfCarlIcon,
    lightColors: {
      light: '#ffffff',
      main: '#182F3E',
      background: '#182F3E',
      logo: '#fff',
      dark: '#182F3E',
      textOnBg: '#fff',
    },
  },
  {
    organizationName: 'Blåkläder',
    type: 'retailer',
    organizationId: '51c8ef26-1d9d-4ac8-b1c2-b782a04772c2',
    icon: BlakladerIcon,
    lightColors: {
      light: '#ffffff',
      main: '#0F1522',
      background: '#182F3E',
      logo: '#fff',
      dark: '#182F3E',
      textOnBg: '#fff',
    },
  },
  {
    organizationName: 'Jula',
    type: 'retailer',
    organizationId: '9c9e1d70-762b-47ee-b5f4-e8e3239003a3',
    icon: JulaIcon,
    lightColors: {
      light: '#ffffff',
      main: '#BE372C',
      background: '#BE372C',
      logo: '#fff',
      dark: '#BE372C',
      textOnBg: '#fff',
    },
  },
  {
    organizationName: 'Lindex',
    type: 'retailer',
    organizationId: '13ecdf48-5803-439a-8832-76c4ad0664d1',
    icon: LindexIcon,
    lightColors: {
      light: '#ffffff',
      main: '#C93137',
      logo: '#C93137',
      background: '#fff',
      textOnBg: '#C93137',
      dark: '#C93137',
    },
  },
  {
    organizationId: 'd3657c3c-288e-4474-97e6-e7a378aef794',
    organizationName: 'Skrym',
    additionalIds: ['7d1cbf93-4ef7-4c8b-8973-ebc9a8e18933'],
    type: 'skrym',
    icon: SkrymIcon,
    lightColors: {
      light: '#ffffff',
      main: '#f8ea21',
      background: '#f8ea21',
      logo: '#000000',
      dark: '#1e1e1e',
      textOnBg: '#ffffff',
    },
  },
  {
    organizationId: '3e7df604-e046-4b52-93a2-f6dbbc32b172',
    organizationName: 'Ongoing',
    type: 'system',
    icon: OngoingIcon,
    lightColors: {
      light: '#ffffff',
      main: '#4356A4',
      background: '#4356A4',
      logo: '#ffffff',
      dark: '#1e1e1e',
      textOnBg: '#ffffff',
    },
  },
  postnord,
  dbSchenker,
  earlyBird,
  airmee,
  gordon,
  dhl,
  budbee,
  citymail,
  instabox,
  bring,
  ica,
  posti,
  postNl,
  bestTransport,
  ups,
  dao,
  moveByBike,
  kuehneNagel,
  gelExpressLogistik,
  dpd,
  lgtLogistics,
  usps,
  royalMail,
  asendia,
  deutschePost,
  swissPost,
  helthjem,
  {
    organizationName: 'Encore',
    type: 'system',
    icon: EncoreIcon,
  },
  {
    organizationName: 'Wikipedia',
    type: 'other',
    icon: WikipediaIcon,
  },
  {
    organizationName: 'Youtube',
    type: 'other',
    icon: YoutubeIcon,
  },
  {
    organizationName: 'Github',
    type: 'other',
    icon: GithubIcon,
  },
  {
    organizationName: 'Figma',
    type: 'other',
    icon: FigmaIcon,
  },
  {
    organizationName: 'Google Sheets',
    type: 'other',
    icon: GoogleSheetsIcon,
  },
  {
    organizationName: 'Google Docs',
    icon: GoogleDocsIcon,
    type: 'other',
  },
  {
    organizationName: 'Google Drive',
    type: 'other',

    icon: GoogleDriveIcon,
  },
  {
    organizationName: 'Google Slides',
    type: 'other',

    icon: GoogleSlidesIcon,
  },
  {
    organizationName: 'Google Cloud',
    type: 'other',

    icon: GoogleCloudIcon,
  },
  {
    organizationId: 'a1720aa9-60a3-4205-82a2-e8fbf5f43ebb',
    organizationName: 'Zendesk',
    type: 'system',

    icon: ZendeskIcon,
    lightColors: {
      light: '#FFFFFF',
      main: '#08292E',
      dark: '#08292E',
      background: '#08292E',
      textOnBg: '#FFFFFF',
      logo: '#FFFFFF',
    },
  },
  {
    organizationId: '3fae7291-f49c-42e1-9e1d-1e44b7658acf',
    organizationName: 'Brink Commerce',
    icon: BrinkCommerceIcon,
    type: 'system',

    lightColors: {
      light: '#4257A3',
      main: '#77DDC3',
      dark: '#4257A3',
      logo: '#141A2A',
      background: '#77DDC3',
      textOnBg: '#FFFFFF',
    },
  },
  {
    organizationId: '13f58310-03a3-48f3-abbb-3adf92c9b9a1',
    organizationName: 'E-motions',
    type: 'system',
    icon: EmotionsIcon,
    lightColors: {
      light: '#25408E',
      main: '#25408E',
      dark: '#25408E',
      background: '#25408E',
      logo: '#FFFFFF',
      textOnBg: '#FFFFFF',
    },
  },
  {
    organizationId: '0c151617-04a8-4dba-939e-7e0d48a9334c',
    organizationName: 'IMI',
    type: 'system',
    icon: IMIIcon,
    lightColors: {
      light: '#31425F',
      main: '#31425F',
      dark: '#31425F',
      background: '#31425F',
      logo: '#FFFFFF',
      textOnBg: '#FFFFFF',
    },
  },
  {
    organizationId: '4c6aef6b-446f-450e-98c1-37a2c99130cb',
    organizationName: 'Klarna',
    type: 'system',

    icon: KlarnaIcon,
    lightColors: {
      light: '##F4B6C7',
      main: '#F4B6C7',
      dark: '#F4B6C7',
      background: '#F4B6C7',
      logo: '#000000',
      textOnBg: '#000000',
    },
  },
  {
    organizationId: 'f078ab82-915b-4d75-825e-f17ec65af5f6',
    organizationName: 'Kustom',
    type: 'system',
    icon: KustomIcon,
    lightColors: {
      light: '##E8FF43',
      main: '#E8FF43',
      dark: '#E8FF43',
      background: '#E8FF43',
      logo: '#000000',
      textOnBg: '#000000',
    },
    darkColors: {
      light: '##E8FF43',
      main: '#E8FF43',
      dark: '#E8FF43',
      background: '#2D2D0B',
      logo: '#000000',
      textOnBg: '#E8FF43',
    },
  },
  {
    organizationId: 'ca0f7089-c964-47f2-a35e-8eeb5d7f623a',
    organizationName: 'Microsoft',
    type: 'system',
    icon: MicrosoftIcon,
    lightColors: {
      light: '##69CFB8',
      main: '#69CFB8',
      dark: '#69CFB8',
      textOnBg: '#69CFB8',
      background: '#e1e1e1',
      logo: '#69CFB8',
    },
  },
  {
    organizationId: '3e7df604-e046-4b52-93a2-f6dbbc32b172',
    organizationName: 'Ongoing',
    icon: OngoingIcon,
    type: 'system',
    lightColors: {
      light: '#4257A3',
      main: '#4257A3',
      dark: '#4257A3',
      background: '#4257A3',
      logo: '#FFFFFF',
      textOnBg: '#FFFFFF',
    },
  },
  {
    organizationId: '33e27b74-34e3-4def-80c5-7139b3ab8729',
    organizationName: 'Qliro',
    type: 'system',
    icon: QliroIcon,
    lightColors: {
      light: '##69CFB8',
      main: '#69CFB8',
      dark: '#69CFB8',
      background: '#000000',
      logo: '#69CFB8',
      textOnBg: '#69CFB8',
    },
  },
  {
    organizationId: 'a9279a47-f0d5-418b-899a-9b0d983024d9',
    organizationName: 'Walley',
    type: 'system',
    icon: WalleyIcon,
    lightColors: {
      light: '#FFFFFF',
      main: '#0A2229',
      dark: '#0A2229',
      background: '#0A2229',
      logo: '#FFFFFF',
      textOnBg: '#FFFFFF',
    },
  },
  {
    organizationId: '02da6b59-5df4-4c93-9973-e732b2cab775',
    organizationName: 'Apotea',
    type: 'retailer',
    icon: ApoteaIcon,
    logo: ApoteaLogo,
    lightColors: {
      background: 'red',
      main: 'red',
      logo: 'white',
      textOnBg: 'red',
      packageVisualizationColors: {
        backgroundColor: '#ffffff',
        logoColor: 'red',
      },
    },
  },
  {
    organizationId: '603f5696-a3b7-4222-a55d-f5d5c12e216c',
    organizationName: 'Bresser',
    type: 'retailer',
    icon: BresserIcon,
    logo: BresserLogo,
    lightColors: {
      main: '-',
      background: '-',
      logo: '-',
      dark: '-',
      textOnBg: '-',
      packageVisualizationColors: {
        backgroundColor: '#AF977E',
        logoColor: '#1a1a1a',
      },
    },
  },
  {
    organizationId: 'b2030fd0-ca2c-43ce-8e76-23c3373b81f9',
    organizationName: 'Cervera',
    type: 'retailer',
    icon: CerveraIcon,
    logo: CerveraLogo,
    lightColors: {
      main: '#426569',
      background: '#426569',
      logo: '#ffffff',
      dark: '#426569',
      textOnBg: '#ffffff',
      packageVisualizationColors: {
        backgroundColor: '#426569',
        logoColor: '#ffffff',
        lineColorDarkenAmount: 0.075,
      },
    },
  },
  {
    organizationId: '5ad61439-4531-49a0-87a4-03b50ed02f22',
    organizationName: 'Gardenstore',
    type: 'retailer',
    icon: GardenstoreIcon,
  },
  {
    organizationId: '52ae61d9-df35-490f-83d6-450ed07ede0c',
    organizationName: 'Happy Green',
    type: 'retailer',
    icon: HappyGreenIcon,
    logo: HappyGreenIcon,
    lightColors: {
      main: '#426569',
      background: '#426569',
      logo: '#ffffff',
      dark: '#426569',
      textOnBg: '#ffffff',
      packageVisualizationColors: {
        backgroundColor: '#AF977E',
        logoColor: '#426569',
      },
    },
  },
  {
    organizationId: 'c024eb89-c4d7-446a-a44c-a2fb1f13fccd',
    organizationName: 'Glimja',
    type: 'retailer',
    icon: GlimjaIcon,
    logo: GlimjaLogo,
    lightColors: {
      logo: 'white',
      background: '#0C543F',
      main: '#0C543F',
      textOnBg: 'white',
    },
  },
  {
    organizationId: '9ed15861-48e0-4f84-bd56-51923949f191',
    organizationName: 'Horseonline',
    lightColors: {
      logo: '#EB4A3C',
      background: '#284A5D',
      main: '#284A5D',
      textOnBg: '#F1EFEA',
    },
    type: 'retailer',
    icon: HorseonlineIcon,
  },
  {
    organizationId: '67fbbbcf-4737-4dbb-805f-96643a04eb2e',
    organizationName: 'Inet',
    type: 'retailer',
    icon: InetIcon,
    logo: InetLogo,
    lightColors: {
      logo: 'white',
      background: '#c0281b',
      main: '#c0281b',
      textOnBg: 'white',
      packageVisualizationColors: {
        backgroundColor: '#AF977E',
        logoColor: 'black',
      },
    },
  },
  {
    organizationId: '7b174dd2-a92e-4439-89a0-ea6803ec31a0',
    organizationName: 'Kitchn',
    type: 'retailer',
    additionalIds: ['53a77683-6b00-49fb-bb50-6a18f031db5e'],
    icon: KitchnIcon,
    logo: KitchnIcon,
    lightColors: {
      logo: 'white',
      background: 'black',
      main: 'black',
      textOnBg: 'white',
      packageVisualizationColors: {
        backgroundColor: '#1a1a1a',
        logoColor: 'white',
      },
    },
  },
  {
    organizationId: '',
    organizationName: 'Tilbords',
    type: 'retailer',
    icon: KitchnIcon,
    logo: TilbordsLogo,
    lightColors: {
      logo: 'white',
      background: 'black',
      main: 'black',
      textOnBg: 'white',
      packageVisualizationColors: {
        backgroundColor: '#eeeeee',
        logoColor: 'black',
      },
    },
  },
  {
    organizationId: '8869d9bb-4868-4b88-8271-cfe2a5c6bf86',
    organizationName: 'Life Logistics',
    type: 'retailer',
    icon: LifeLogisticsIcon,
    logo: LifeLogisticsIcon,
    lightColors: {
      logo: 'white',
      background: '#2C5D54',
      main: '#2C5D54',
      textOnBg: 'white',
      packageVisualizationColors: {
        backgroundColor: '#2C5D54',
        logoColor: 'white',
      },
    },
  },
  {
    organizationId: 'c2fb5b82-8a08-4326-aa42-583ed950bf9b',
    organizationName: 'MEDS',
    type: 'retailer',
    icon: MedsIcon,
    lightColors: {
      logo: 'white',
      background: '#DC7484',
      main: '#DC7484',
      textOnBg: 'white',
      packageVisualizationColors: {
        backgroundColor: '#DC7484',
        logoColor: 'white',
      },
    },
  },
  {
    organizationId: 'f34c26db-8c60-4f59-9f7b-30a1a87d33ec',
    organizationName: 'MM Sports',
    type: 'retailer',
    icon: MMSportsIcon,
    logo: MMSportsLogo,
    lightColors: {
      logo: 'white',
      background: 'black',
      main: 'black',
      textOnBg: 'white',
      packageVisualizationColors: {
        backgroundColor: '#AF977E',
        logoColor: 'black',
      },
    },
  },
  {
    organizationId: '0ffe730a-1a1c-4b6b-9c0c-030f6d3fd776',
    organizationName: 'RevolutionRace',
    type: 'retailer',
    icon: RevolutionRaceIcon,
    lightColors: {
      logo: 'white',
      background: 'black',
      main: 'black',
      textOnBg: 'white',
    },
  },
  {
    organizationId: '257c0ec8-6c99-443e-a9b4-8069f2e25250',
    organizationName: 'Klint Home',
    type: 'retailer',
    icon: KlintIcon,
    lightColors: {
      logo: 'white',
      background: '#222B36',
      main: '#222B36',
      textOnBg: '#222B36',
    },
  },
  {
    organizationId: '2ad25049-f750-463a-a18d-bcdc0a3c1ca5',
    organizationName: 'Twistshake',
    type: 'retailer',
    logo: TwistshakeLogo,
    icon: TwistshakeLogo, // TODO: Replace with TwistshakeIcon
    lightColors: {
      light: '#ffffff',
      main: '#1a1a1a',
      background: '#1a1a1a',
      logo: '#000000',
      dark: '#000000',
      textOnBg: '#ffffff',
      packageVisualizationColors: {
        backgroundColor: '#EBB4C9',
        logoColor: '#000000',
        lineColorDarkenAmount: 0.09,
      },
    },
  },
  {
    organizationId: '299a8a9c-d286-4f0e-b452-7fafedead82c',
    organizationName: 'Nelly',
    type: 'retailer',
    icon: NellyIcon,
    lightColors: {
      light: '#ffffff',
      main: '#1a1a1a',
      background: '#EBB4C9',
      logo: '#000000',
      dark: '#000000',
      textOnBg: '#ffffff',
      packageVisualizationColors: {
        backgroundColor: '#EBB4C9',
        logoColor: '#000000',
        lineColorDarkenAmount: 0.09,
      },
    },
  },
  {
    organizationId: '',
    organizationName: 'Svenska Hem',
    type: 'retailer',
    icon: SvenskaHemIcon,
    logo: SvenskaHemIcon,
    lightColors: {
      light: '#ffffff',
      main: '#1a1a1a',
      background: '#d70911',
      logo: '#000000',
      dark: '#000000',
      textOnBg: '#ffffff',
      packageVisualizationColors: {
        backgroundColor: '#AF977E',
        logoColor: '#1a1a1a',
      },
    },
  },
  {
    organizationName: 'Svanen',
    type: 'other',
    icon: SvanenIcon,
  },
  {
    organizationName: 'GLEC',
    type: 'other',
    icon: GlecIcon,
  },
  {
    organizationName: 'Science Based Targets',
    type: 'other',
    icon: ScienceBasedTargetsIcon,
  },
  {
    organizationName: 'Adyen',
    type: 'system',
    icon: AdyenIcon,
    lightColors: {
      main: '#0A1F2D',
      background: '#0A1F2D',
      logo: '#ffffff',
      dark: '#0A1F2D',
      textOnBg: '#ffffff',
    },
  },
  {
    organizationName: 'Centra',
    type: 'system',
    icon: CentraIcon,
    lightColors: {
      main: '#0A1F2D',
      background: '#0A1F2D',
      logo: '#ffffff',
      dark: '#0A1F2D',
      textOnBg: '#ffffff',
    },
  },
  {
    organizationName: 'Commercetools',
    type: 'system',
    icon: CommerceToolsIcon,
    lightColors: {
      main: '#0A1F2D',
      background: '#0A1F2D',
      logo: '#ffffff',
      dark: '#0A1F2D',
      textOnBg: '#ffffff',
    },
  },
  {
    organizationName: 'Element Logic',
    type: 'system',
    icon: ElementLogicIcon,
    lightColors: {
      main: '#0A1F2D',
      background: '#0A1F2D',
      logo: '#ffffff',
      dark: '#0A1F2D',
      textOnBg: '#ffffff',
    },
  },
  {
    organizationName: 'Inriver',
    type: 'system',
    icon: InriverIcon,
    lightColors: {
      main: '#0A1F2D',
      background: '#0A1F2D',
      logo: '#ffffff',
      dark: '#0A1F2D',
      textOnBg: '#ffffff',
    },
  },
  {
    organizationName: 'Norce',
    type: 'system',
    icon: NorceIcon,
    lightColors: {
      main: '#0A1F2D',
      background: '#0A1F2D',
      logo: '#ffffff',
      dark: '#0A1F2D',
      textOnBg: '#ffffff',
    },
  },
  {
    organizationName: 'PinMeTo',
    type: 'system',
    icon: PinMeToIcon,
    lightColors: {
      main: '#0A1F2D',
      background: '#0A1F2D',
      logo: '#ffffff',
      dark: '#0A1F2D',
      textOnBg: '#ffffff',
    },
  },
  {
    organizationName: 'Stripe',
    type: 'system',
    icon: StripeIcon,
    lightColors: {
      main: '#0A1F2D',
      background: '#0A1F2D',
      logo: '#ffffff',
      dark: '#0A1F2D',
      textOnBg: '#ffffff',
    },
  },
  {
    organizationName: 'WooCommerce',
    type: 'system',
    icon: WooCommerceIcon,
    lightColors: {
      main: '#0A1F2D',
      background: '#0A1F2D',
      logo: '#ffffff',
      dark: '#0A1F2D',
      textOnBg: '#ffffff',
    },
  },
];

/**
 * Retrieves the organization assets that match the given name or ID.
 *
 * @param name - The organization name or ID to search for.
 * @returns The matching `OrganizationAssets` object if found; otherwise, `undefined`.
 *
 * @remarks
 * This function searches through a list of organization assets and returns the one that matches the provided name or ID.
 * It performs a case-insensitive comparison on organization names and additional names.
 * It also checks for exact matches on `organizationId` and any `additionalIds`.
 */
export function getOrganizationAssets(name: string) {
  return organizationAssets.find((asset) => {
    if (asset.organizationId && caseInsensitiveStringCompare(asset.organizationId, name)) {
      return true;
    }

    if (caseInsensitiveStringCompare(asset.organizationName, name)) {
      return true;
    }

    if (
      asset.additionalNames?.some((additionalName) =>
        caseInsensitiveStringCompare(additionalName, name),
      )
    ) {
      return true;
    }

    if (
      asset.additionalIds?.some((additionalId) => caseInsensitiveStringCompare(additionalId, name))
    ) {
      return true;
    }

    return false;
  });
}
